import { BiErrorCircle } from 'react-icons/bi'
import { Icon, IconProps, forwardRef } from '@chakra-ui/react'

export const OmError = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} {...props} as={BiErrorCircle} />
))
